import './index.scss'
import Swiper from 'swiper/dist/js/swiper.min.js'

!(function(){
  $('.header').addClass('black')
})()

if($(window).width()>1024){
	var itemheight = 0;
	$('.section1 .cont .info .item').each(function(index) {
	if(index < 2) {
		itemheight += $(this).outerHeight(true);
	}
	});
	$('.section1 .cont .info').css('max-height', itemheight);
}
	
var swiper = new Swiper(".section1 .swiper", {
  allowTouchMove: false,
  effect : 'fade',
  on:{
    init:function(){
      $('.section1 .info .item').eq(0).addClass('active')
    },
    transitionStart: function(){
      this.realIndex
      $('.section1 .info .item').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
});

$('.section1 .info .item').hover(function(){
  let index = $(this).index()
  swiper.slideTo(index)
})